/* CUSTOM product-media-numbered-nav.js — Nummer-Nav (1 · 2 · 3) an der
 * Produkt-Media-Galerie. Zeigt NUR sichtbare Slides (data-is-inuse Filter
 * beruecksichtigt). Wenn <=1 Slide sichtbar: Nav ausgeblendet.
 *
 * Klick auf eine Zahl klickt das entsprechende Origin-Thumbnail (nutzt Origin-Handler).
 * Aktueller Slide wird via aria-current aus dem Origin-Slider gespiegelt.
 * Rebuild bei inuse-mode-changed (product-gallery-inuse-order.js).
 */
(() => {
  function visibleSlides(slider) {
    // Nav zeigt immer die non-inuse Slides — der Toggle ersetzt nur den ersten
    // Slot durch ein [inuse]-Bild, die Nav-Positionen bleiben identisch.
    return [...slider.querySelectorAll('.product__media-item[data-is-inuse="0"]')];
  }

  function buildNav(nav) {
    const targetId = nav.getAttribute('data-nav-target');
    const slider = document.getElementById(targetId);
    if (!slider) return;
    const slides = visibleSlides(slider);

    if (slides.length < 2) {
      nav.innerHTML = '';
      nav.hidden = true;
      return;
    }
    nav.hidden = false;
    nav.innerHTML = '';
    slides.forEach((slide, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product__media-nav-btn';
      btn.textContent = String(i + 1);
      btn.setAttribute('aria-label', `Bild ${i + 1} von ${slides.length}`);
      btn.dataset.mediaId = slide.getAttribute('data-media-id') || '';
      if (slide.classList.contains('is-active')) btn.setAttribute('aria-current', 'true');
      nav.appendChild(btn);
    });
  }

  function jumpTo(mediaId) {
    if (!mediaId) return;
    const thumb = document.querySelector(`[data-target="${mediaId}"] .thumbnail`);
    if (thumb) { thumb.click(); return; }
    const slide = document.querySelector(`[data-media-id="${mediaId}"]`);
    if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function syncActive(nav) {
    const targetId = nav.getAttribute('data-nav-target');
    const slider = document.getElementById(targetId);
    if (!slider) return;
    nav.querySelectorAll('.product__media-nav-btn').forEach(btn => {
      const id = btn.dataset.mediaId;
      const slide = slider.querySelector(`[data-media-id="${id}"]`);
      if (slide && slide.classList.contains('is-active')) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });
  }

  function init() {
    document.querySelectorAll('[data-media-numbered-nav]').forEach(nav => {
      buildNav(nav);

      nav.addEventListener('click', e => {
        const btn = e.target.closest('.product__media-nav-btn');
        if (!btn) return;
        jumpTo(btn.dataset.mediaId);
      });

      const targetId = nav.getAttribute('data-nav-target');
      const slider = document.getElementById(targetId);
      if (slider) {
        const obs = new MutationObserver(() => syncActive(nav));
        slider.querySelectorAll('.product__media-item').forEach(li =>
          obs.observe(li, { attributes: true, attributeFilter: ['class'] })
        );
      }

      // Rebuild bei Toggle-Wechsel: product-gallery-inuse-order.js feuert.
      document.documentElement.addEventListener('inuse-mode-changed', () => {
        buildNav(nav);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
